import { useTranslation } from "react-i18next"
import { Dialog, DialogContent, DialogHeader, DialogOverlay, DialogPortal, DialogTitle } from "@/components/ui/dialog"
import { UploadForm } from "@/modules/upload/upload-form"
import { Country } from "@/types/__generated__/union-types"

type UploadDialogProps = {
  appointmentId?: string
  progressNoteId?: string
  country?: Country
  onOpenChange: (open: boolean) => void
}

export const UploadDialog = ({ appointmentId, progressNoteId, country, onOpenChange }: UploadDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay onMouseDown={(e) => e.stopPropagation()} />
        <DialogContent
          data-testid="upload-dialog-content"
          className="flex max-h-full flex-col"
          variant="small"
          onMouseDown={(e) => e.stopPropagation()}
          onPointerDownOutside={(e) => e.preventDefault()}>
          <DialogHeader>
            <DialogTitle>{t("patient.uploadFiles.uploadFiles")}</DialogTitle>
          </DialogHeader>
          <UploadForm
            appointmentId={appointmentId}
            progressNoteId={progressNoteId}
            country={country}
            onClose={() => onOpenChange(false)}
          />
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
}
